import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import { palette } from '@primevue/themes'
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';

import './assets/base.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(ToastService)
app.use(ConfirmationService)


const MyPreset = definePreset(Aura, {
    semantic: {
        // primary: palette('{blue}')
        primary: palette('000B66'),
        highlight: palette('FF8050'),
    }
});

app.use(PrimeVue, {
    theme: {
        preset: MyPreset,
        options: {
                name: 'primevue',
                order: 'tailwindcss, primevue',
                darkModeSelector: 'none' // Disable automatic dark mode
            }
        
    }
});


// import Stepper from 'primevue/stepper';
// import StepList from 'primevue/steplist';
// import StepPanels from 'primevue/steppanels';
// import StepItem from 'primevue/stepitem';
// import Step from 'primevue/step';
// import StepPanel from 'primevue/steppanel';
import { 
    DataView, 
    Card,
    Divider,
    MultiSelect,
    Drawer,
    Button,
    Fieldset,
    Panel,
    RadioButton,
    Checkbox,
    Dialog,
    InputText,
    InputNumber,
    Textarea,
    Stepper,
    StepList,
    StepPanels,
    StepItem,
    Step,
    StepPanel,
    Select,
    Tabs,
    TabList,
    TabPanel,
    Tab,
    Tooltip,
    DatePicker,
    ProgressSpinner,
    DataTable,
    Column,
    ColumnGroup,
    ScrollPanel,
    Menu,
    ProgressBar
 } from 'primevue'
import Toast from 'primevue/toast'
import Badge from 'primevue/badge'
import Dropdown from 'primevue/dropdown'
import ConfirmDialog from 'primevue/confirmdialog'
import { definePreset } from '@primevue/themes'
app.component('DataView', DataView)
app.component('Card', Card)
app.component('Divider', Divider)
app.component('MultiSelect', MultiSelect)
app.component('Drawer', Drawer)
app.component('Button', Button)
app.component('Fieldset', Fieldset)
app.component('Panel', Panel)
app.component('RadioButton', RadioButton)
app.component('Checkbox', Checkbox)
app.component('Dialog', Dialog)
app.component('Toast', Toast)
app.component('Badge', Badge)
app.component('Dropdown', Dropdown)
app.component('ConfirmDialog', ConfirmDialog)
app.component('InputText', InputText)
app.component('InputNumber', InputNumber)
app.component('Stepper', Stepper)
app.component('StepList', StepList)
app.component('StepPanels', StepPanels)
app.component('StepItem', StepItem)
app.component('Step', Step)
app.component('StepPanel', StepPanel)
app.component('Textarea', Textarea)
app.component('Select', Select)
app.component('DatePicker', DatePicker)
app.component('ProgressSpinner', ProgressSpinner)
app.component('DataTable', DataTable)
app.component('Column', Column)
app.component('ColumnGroup', ColumnGroup)
app.component('ScrollPanel', ScrollPanel)
app.component('Tabs', Tabs)
app.component('TabList', TabList)
app.component('TabPanel', TabPanel)
app.component('Tab', Tab)
app.component('Menu', Menu)
app.component('ProgressBar', ProgressBar)

app.directive('tooltip', Tooltip);

app.mount('#app')
